export enum ContainerSize {
  MOBILE = 'mobile',
  TABLET_PORTRAIT = 'tablet-portrait',
  TABLET_LANDSCAPE = 'tablet-landscape',
  DESKTOP = 'desktop'
}
